import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "franchisee-wrapper"
};
import { ref, computed } from 'vue';
import FranchiseeTag from './FranchiseeTag.vue';
import FranchiseePicker from './FranchiseePicker.vue';
export default {
  __name: 'index',
  props: {
    modelValue: {
      type: [Array, String, Number],
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择加盟商'
    }
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const $props = __props;
    const $emits = __emit;
    const pickerRef = ref();
    const disabled = computed(() => $props.disabled);
    const valueArr = computed(() => {
      if (!$props.modelValue) return [];
      return Array.isArray($props.modelValue) ? $props.modelValue : [$props.modelValue];
    });
    const openPicker = () => {
      pickerRef.value?.open();
    };
    const onClose = id => {
      if (!$props.modelValue) return;
      if ($props.multiple && Array.isArray($props.modelValue)) {
        const newValue = $props.modelValue.filter(item => {
          const itemId = typeof item === 'object' ? item.id : item;
          return String(itemId) !== String(id);
        });
        $emits('update:modelValue', newValue);
      } else {
        $emits('update:modelValue', null);
      }
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_text = _resolveComponent("el-text");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(FranchiseePicker, {
        ref_key: "pickerRef",
        ref: pickerRef,
        multiple: __props.multiple,
        "model-value": __props.modelValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event))
      }, null, 8, ["multiple", "model-value"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
        class: "franchisee-btn-item",
        disabled: disabled.value,
        onClick: openPicker,
        circle: ""
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
        })], -1)]))]),
        _: 1
      }, 8, ["disabled"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(valueArr.value, item => {
        return _openBlock(), _createBlock(FranchiseeTag, {
          closable: !disabled.value,
          key: typeof item === 'object' ? item.id : item,
          id: typeof item === 'object' ? item.id : item,
          name: typeof item === 'object' ? item.name : '',
          onClose: $event => onClose(typeof item === 'object' ? item.id : item)
        }, null, 8, ["closable", "id", "name", "onClose"]);
      }), 128)), _withDirectives(_createVNode(_component_el_text, {
        class: "placeholder"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(__props.placeholder), 1)]),
        _: 1
      }, 512), [[_vShow, !__props.modelValue || Array.isArray(__props.modelValue) && __props.modelValue.length === 0]])])], 64);
    };
  }
};